/*
Infomation
==========================================================================================
jQuery Plugin
	Name       : jquery.ajaxSuggest2
	Version    : 0.01
	Update     : 2015-12-22
	Author     : Atsushi Umehara
==========================================================================================
*/
(function($) {
	//================================================================================
	// PC版
	//--------------------------------------------------------------------------------
	$.fn.ajaxSuggestPC = function(source, option) {
		//Ajaxにおけるキャッシュを無効にする
		$.ajaxSetup({cache: false});

		var timeID = null;
		var prev_word=null;
		var searching = false; //現在検索しているか
		var prev_line = false;	//以前選択していたライン
		var search_word = null;				//検索文字

		//基本設定
		option = $.extend({
			padding_left_add   : "0"
		}, option);

		//セレクタ
		var input_obj = $("#as2_search_box");

		//-------------------------------------
		//検索窓にフォーカスがはいったとき
		//-------------------------------------
		input_obj.focus(function(){
			//Ajax呼び出し
			ajax_exec();
		});

		//-------------------------------------
		//検索語が変わった時
		//-------------------------------------
		input_obj.keyup(function(e){
			//Ajax呼び出し
			ajax_exec();
		});

		//-------------------------------------
		//検索窓からフォーカスが外れたとき
		//-------------------------------------
		input_obj.blur(function(e){
//			prev_word=null;
//			setTimeout("$('#as2_suggestions').fadeOut().remove();", 300);
		});


		//-------------------------------------
		//	Ajax本体
		//-------------------------------------
		function ajax_exec()
		{
			var input_obj = $("#as2_search_box");
			var offset = $(input_obj).offset();
			var goods_id = $("#goods_id").html();

			//bsキー
			search_word = input_obj.val();
			if(prev_word == search_word) return;
			prev_word=search_word;

			//Windowの縦サイズに応じて表示最大数を変える
			window_inner_height = window.innerHeight;

			$.post(source,{
					search_txt:search_word,
					window_inner_height:window_inner_height,
					goods_id:goods_id
				}, function(data){
				searching = false;
				if(data.length >0) {
					$('.as2_suggestionsBox').remove();
					$('body').append(data);

					//候補リストの位置を指定
					var offset = $(input_obj).offset();
					offset.top +=
						parseInt($(input_obj).height(), 10) +
						parseInt($(input_obj).css('border-top-width'), 10) +
						parseInt($(input_obj).css('padding-top'), 10) +
						parseInt($(input_obj).css('padding-bottom'), 10);
					offset.left += parseInt($(input_obj).css('padding-left'), 10);
					if(typeof(option.padding_left_add) != "undefined"){
						offset.left += parseInt(option.padding_left_add);
					}

					$('#as2_suggestions').css({'top':offset.top, 'left':offset.left}).fadeIn();
					$('#as2_search_box').removeClass('load');

					//イベントをアペンド
					mouse_hover_and_select();
					as2_suggestionList_click();
				}
			});
		}

		//-------------------------------------
		//マウスで選択
		//-------------------------------------
		function mouse_hover_and_select(){
			$(".as2_suggestionList li").hover(function(){

				now_line = $(this).attr("data-line");
				if(prev_line == now_line) return;
				prev_line = now_line;

				$(".as2_suggestionList li").removeClass("selected");
				$(this).addClass("selected");
				after_selected();	//選択後の処理
			});
		}

		//-------------------------------------
		//選択の上下
		//-------------------------------------
		input_obj.keydown(function(e){
			if (e.keyCode == 38) { // up
			console.log("up");
			    var selected = $(".as2_suggestionList .selected");
			    $(".as2_suggestionList li").removeClass("selected");

			    // if there is no element before the selected one, we select the last one
			    if (selected.prev().length == 0) {
			        selected.siblings(":last").addClass("selected");
			    } else { // otherwise we just select the next one
			        selected.prev().addClass("selected");
			    }

					after_selected();	//選択後の処理
			}

			if (e.keyCode == 40) { // down
			console.log("down");
			    var selected = $(".as2_suggestionList .selected");
			    $(".as2_suggestionList li").removeClass("selected");

					//初回の時
					if(!selected.length){
						selected = $(".as2_suggestionList").children().children(":first-child");
						selected.addClass("selected");
					}else{
						//既に何か選択されている時
				    // if there is no element before the selected one, we select the last one
				    if (selected.next().length == 0) {
				        selected.siblings(":first").addClass("selected");
				    } else { // otherwise we just select the next one
				        selected.next().addClass("selected");
				    }
					}
					after_selected();	//選択後の処理

			}
		});


		//-------------------------------------
		//選択後の処理
		//-------------------------------------
		function after_selected(){
			selected_obj = $("#as2_suggestions .selected:first");

//			$("#as2_search_box").val(selected_obj.html());	//テキストBOXに文字入れる
			//横の写真入りBOXを表示
			$(".as2_searchResult").children().stop();
			$(".as2_searchResult").children().hide();

			prev_line = selected_obj.attr("data-line");

			var txt = "#as2_searchResult"+selected_obj.attr("data-line");
			if($(txt).length){
				$("#as2_searchResult").show();
				$(txt).fadeIn(100);
			}else{
				$("#as2_searchResult").hide();
			}
		}

		//お勧めリストがクリック
		function as2_suggestionList_click(){
			$(".as2_suggestionList li").click(function(){
				if($(this).data('target_url')){
					window.location.href = $(this).data('target_url');
				}else{
					window.location.href = "https://www.tirakita.com/"+$(this).html();
				}
			});
		}

		//メソッドチェーン対応(thisを返す)
		return(this);
	};


	//================================================================================
	// スマホ版
	//--------------------------------------------------------------------------------
	$.fn.ajaxSuggestSMAHO = function(source, option) {

		//要素を追加
		//2019年2月8日 as2_search_boxをabsoluteにしたら、デザインが崩れるので、デザインが崩れないようにabsoluteでas2_search_box_cpyを追加し、上に乗せることにした。as2_search_box_cpyの入力内容はas2_search_boxに入力があり次第、コピーされる。

		$("body").append("<div id='kensaku_helper_bg'></div><div id='kensaku_helper'><div class='inner'></div></div>");

		//ソースから一部分を抜いてきてIDだけ変更
		//as2_search_boxをas2_search_box_cpyに
		//as2_search_formをas2_search_form_cpyに
		//search_submitを#search_submit2に
		var html = $('#as2_search_form').prop('outerHTML');
		html = html.replace('as2_search_form','as2_search_form_cpy').replace('as2_search_box','as2_search_box_cpy').replace('search_submit','search_submit2');
		html = "<div id='header_search_search_cpy'>"+html+"</div>";
		$("body").append(html);


		//イベントを追加
		$('#search_submit2').click(function(){
			$('#as2_search_form_cpy').submit();
		});

		//Ajaxにおけるキャッシュを無効にする
		$.ajaxSetup({cache: false});

		//セレクタ
		var bg_obj = $("#as2_search_box");
		var input_obj = $("#as2_search_box_cpy");

		//-------------------------------------
		//	検索窓にフォーカスが当たった
		//-------------------------------------
		bg_obj.focus(function(){

			//検索boxの外側のDIVの位置を合わせる
			var pos = bg_obj.parent().offset();
			input_obj.parent().css("top",pos.top);
			input_obj.parent().css("left",pos.left);

			//検索boxのサイズを合わせる
			var pos = bg_obj.offset();
			input_obj.css("width",bg_obj.width());
//			input_obj.css("height",bg_obj.height());

			//プレースホルダーの取得を設定
			input_obj.attr('placeholder',bg_obj.attr('placeholder'));

			//検索の下に出るヘルパーの位置合わせ
			var pos = $(this).offset();
			var height = $(this).height()+15;
			$("#kensaku_helper").css("top",pos.top+height);
			$("#kensaku_helper").addClass("search_box_zoomin");
			$("#as2_search_box_cpy").css("display","block");


			//表示開始
			$("#header_search_search_cpy").show();
			$("#kensaku_helper_bg").show();
			$("#kensaku_helper").show();
			$("#as2_search_form_cpy").show();
			$("#as2_search_box_cpy").show();

			//検索語をコピー&カーソルを最後尾に
			input_obj.val('');
			input_obj.focus();
			input_obj.val(bg_obj.val());

			//ヘルパーの中に読み込み
			ajax_exec();

		});

		//-------------------------------------
		//	検索語が変わった
		//-------------------------------------
		input_obj.keyup(function(e){
			$("#as2_search_box").val($("#as2_search_box_cpy").val());
			ajax_exec()
		});

		//-------------------------------------
		//	Ajax本体
		//-------------------------------------
		function ajax_exec()
		{
			var search_txt = input_obj.val();
			if(!search_txt) search_txt = $("#html_encoded_query").val();

			var goods_id = $("#goods_id").html();
			var token = $("#token").val();
			var db_get_mode = $("#db_get_mode").val();
			var db_get_search_txt = $("H1").html();

			$.ajax({
				type: "post",
				url: source,
				dataType: 'json',
				data: {
					goods_id:goods_id,
					db_get_mode:db_get_mode,
					db_get_search_txt: db_get_search_txt,
					search_txt: search_txt,
					token:token
				},
				success: function(json){
					$("#kensaku_helper .inner").html(json.html);
				}
			});
		}

		//-------------------------------------
		//	検索窓からフォーカスが外れた
		//-------------------------------------
		$("#kensaku_helper_bg").click(function(){
			$("#header_search_search_cpy").hide();
			$("#as2_search_form_cpy").hide();
			$("#as2_search_box_cpy").hide();
			$("#kensaku_helper").hide(100);
			$("#kensaku_helper_bg").hide(); 
			return(this);

		});


		//メソッドチェーン対応(thisを返す)
		return(this);
	};

})(jQuery);

/*-------------------------------------------------
		検索窓-オートコンプリート
-------------------------------------------------*/

$(function(){
	if($(window).width() > 660){
	  $('#search_form_txt').ajaxSuggestPC('https://www.tirakita.com/sys/HP_Make/autocomplete_ajax.php');
	} else{
	  $('#search_form_txt').ajaxSuggestSMAHO('https://www.tirakita.com/sys/HP_Make/autocomplete_ajax_sumaho.php');
	}
});
